import { api } from "shared/config/api/api";
import { BalanceStatus, Stats } from "./../model/types";

export const statsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserStats: builder.query<Stats, void>({
      query: () => "/users/deals/stats",
      providesTags: ["UserStats"],
    }),
    getUserBalanceStatus: builder.query<BalanceStatus, void>({
      query: () => "/users/balance-status",
      providesTags: ["UserBalanceStatus"],
    }),
  }),
});

export const { useGetUserStatsQuery, useGetUserBalanceStatusQuery } = statsApi;
